import { Blocks } from 'lucide-react';
import useAuthStore from '../store/authStore';
import useModulosAvanzados from '../hooks/useModulosAvanzados';

/**
 * Envoltorio de la pantalla de un Módulo Avanzado: si la empresa no lo tiene, muestra el aviso en lugar
 * de la pantalla (que no se toca). El servidor también cierra sus rutas.
 */
export default function RequiereModulo({ modulo, children }) {
  const { currentEmisor } = useAuthStore();
  const mods = useModulosAvanzados(currentEmisor?.id);
  if (mods === null) return null;
  if (mods.includes(modulo)) return children;
  return (
    <div className="flex items-center justify-center py-24 px-4">
      <div className="max-w-md text-center border border-gray-200 rounded-2xl bg-white px-8 py-10">
        <Blocks className="h-8 w-8 text-indigo-500 mx-auto mb-3" />
        <p className="font-semibold text-gray-900">Este módulo avanzado no está activo para su empresa</p>
        <p className="text-sm text-gray-500 mt-2">Para activarlo, contacte a su administrador de Finance 360.</p>
      </div>
    </div>
  );
}
